var React = require('react');

function SubmenuToggleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.0303.9697a.7502.7502 0 01.0726.9765l-.0726.0841-7 7a.7502.7502 0 01-.9765.0726l-.0841-.0726-7-7A.75.75 0 011.9462.8971l.0841.0726L8.5 7.439 14.9697.9697a.7502.7502 0 01.9765-.0726l.0841.0726z"}));
}

SubmenuToggleInline.defaultProps = {"width":"17","height":"10","viewBox":"0 0 17 10"};

module.exports = SubmenuToggleInline;

SubmenuToggleInline.default = SubmenuToggleInline;
